module.exports = __webpack_public_path__ + "static/customer-support-cb5a9ca682662f21627c3f4a1e31cb01.png";